export class TabbedAccordion {
    constructor(element) {
        this.element = element;
        this.title = element.querySelector('.accordion__title');
        this.content = element.querySelector('.accordion__content');
        this.isActive = this.element.classList.contains('active');
        this.contentHeight = this.isActive ? this.content.scrollHeight : 0;

        this.title.addEventListener('click', () => {
            this.toggle();
        });

        this.element.tabbedAccordionInstance = this; // Store the TabbedAccordion instance as a property
        this.update();
    }

    toggle() {
        if (this.isActive) {
            return; // Return early if the accordion is already active
        }

        const allAccordions = document.querySelectorAll('.tabbed-content__detail');
        allAccordions.forEach((accordion) => {
            if (accordion !== this.element) {
                accordion.classList.remove('active');
                accordion.querySelector('.accordion__content').style.maxHeight = '0';
                accordion.querySelector('.accordion__title').classList.remove('active');
                const accordionInstance = accordion.tabbedAccordionInstance;
                if (accordionInstance) {
                    accordionInstance.isActive = false; // Set isActive to false for inactive accordions
                }
            }
        });

        this.element.classList.add('active');
        this.title.classList.add('active');
        this.contentHeight = this.content.scrollHeight;
        this.content.style.maxHeight = `${this.contentHeight}px`;
        this.isActive = true;

        this.scrollToAccordion();
    }

    update() {
        if (this.isActive) {
            this.content.style.maxHeight = `${this.contentHeight}px`;
            this.title.classList.add('active');
        } else {
            this.content.style.maxHeight = '0';
            this.title.classList.remove('active');
        }
    }

    scrollToAccordion() {
        const headerHeight = 65; // Adjust this value according to your header height
        const offset = this.title.offsetTop - headerHeight;
        window.scrollTo({top: offset, behavior: 'smooth'});
    }
}
